export const SET_COPPA = "SET_COPPA";
